/*
 * @Descripttion: 
 * @version: 1.0
 * @Author: zhanmei
 * @Date: 2020-09-11 09:49:02
 * @LastEditors: zhanmei
 * @LastEditTime: 2020-09-11 11:56:03
 */
var BaseMsgItem = require('./BaseMsgItem');
var $ = require('jQuery');
var template = require('../../template/msg/audio-msg-item.html');
/*require('./../../style/msg/audio-msg-item.less');*/
var dispatcher = require('./../../global/dispatcher');
var ActionType = require('./../../constant/ActionType');
var MsgStatus = require('./../../constant/MsgStatus');

var AudioMsgItem = function (options) {
    (function (self) {
        var defaults = {
            template: template
        };
        $.extend(defaults, options);
        BaseMsgItem.call(self, defaults);
    })(this);

    // 是否已经被render过
    this._rendered = false;
};
AudioMsgItem.prototype = Object.create(BaseMsgItem.prototype);
AudioMsgItem.prototype.renderContent = function () {
    var self = this;
    var msg = self._data.msg;
    var msgcontent = msg.content;
    var content = self._element.find('.im-msg-main');
    var dur = self._element.find('.im-msg-duration');
    var width = (15 + 5 * msgcontent.duration);
    var icon = content.find('.im-msg-content');

    if (msgcontent.duration >= 60) {
        icon.addClass('im-audio-60');
        // width = 228;
        width = 280;
    } else if (msgcontent.duration >= 30) {
        icon.addClass('im-audio-30');
        // width = 148;
        width = 200;
    }
    width = width <= 165 ? 90 : width;
    content.width(width);
    dur.text(msgcontent.duration + '秒');
    if (msg.play_time + '' !== '0') {
        self._element.find('.im-msg-read-status').addClass('im-audio-read');
    }
    content.click(function () {
        if (self._element.find('.im-audio-playing').length === 0) {
            dispatcher.dispatch({
                type: ActionType.MSG_AUDIO_READ,
                data: msg
            });
        } else {
            dispatcher.dispatch({
                type: ActionType.MSG_AUDIO_READ_END,
                data: msg
            });
        }
    });

    dispatcher.register(function (action) {
        if (!action.data || !action.type || !action.data.msg_id || !self._element) {
            return;
        }
        if (action.data.msg_id === msg.msg_id) {
            switch (action.type) {
                case ActionType.MSG_AUDIO_ACK_READ:
                    self._element.find('.im-msg-read-status').addClass('im-audio-read');
                    break;
                case ActionType.MSG_AUDIO_READ_START:
                    self._element.find('.im-msg-content').find('.im-msg-audio-bg').addClass('im-audio-playing');
                    break;
                case ActionType.MSG_AUDIO_READ_END:
                    self._element.find('.im-msg-content').find('.im-msg-audio-bg').removeClass('im-audio-playing');
                    break;
                default:
                    break;
            }
        } else {
            if (action.type === ActionType.MSG_AUDIO_READ_START) {
                self._element.find('.im-msg-content').find('.im-msg-audio-bg').removeClass('im-audio-playing');
            }
        }
    });
};

module.exports = AudioMsgItem;
